var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { IsInt, IsString, MaxLength } from "class-validator";
import { safeAssign } from "./safe-assign";
export class AcceptJobApplicationDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    IsInt(),
    Expose(),
    __metadata("design:type", Number)
], AcceptJobApplicationDTO.prototype, "applicationId", void 0);
__decorate([
    IsInt(),
    Expose(),
    __metadata("design:type", Number)
], AcceptJobApplicationDTO.prototype, "employeeId", void 0);
export class RejectJobApplicationDTO {
    constructor(props) {
        this.sendEmail = true;
        safeAssign(this, props);
    }
}
__decorate([
    IsInt(),
    Expose(),
    __metadata("design:type", Number)
], RejectJobApplicationDTO.prototype, "applicationId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], RejectJobApplicationDTO.prototype, "sendEmail", void 0);
export class SaveJobApplicationNoteDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    IsInt(),
    Expose(),
    __metadata("design:type", Number)
], SaveJobApplicationNoteDTO.prototype, "applicationId", void 0);
__decorate([
    IsString(),
    MaxLength(1000),
    Expose(),
    __metadata("design:type", String)
], SaveJobApplicationNoteDTO.prototype, "notes", void 0);
//# sourceMappingURL=job-application.dto.js.map